import { ReportFacture } from "@/types/nurse";

export type FactureGroupMode = "none" | "caisse" | "mutuelle";

export type FactureGroup = {
  key: string;
  label: string;
  factures: ReportFacture[];
};

export function groupFactures(factures: ReportFacture[] = [], mode: FactureGroupMode): FactureGroup[] {
  if (mode === "none") {
    return [{ key: "all", label: "Toutes les factures", factures }];
  }

  const fallbackLabel = mode === "caisse" ? "Sans caisse" : "Sans mutuelle";
  const groups = new Map<string, FactureGroup>();

  factures.forEach((facture) => {
    const code = mode === "caisse" ? facture.codeCaisse : facture.codeMutuelle;
    const libelle = mode === "caisse" ? facture.libelleCaisse : facture.libelleMutuelle;
    const key = code || "__none__";
    const label = code ? libelle || code : fallbackLabel;

    if (!groups.has(key)) {
      groups.set(key, { key, label, factures: [] });
    }
    groups.get(key)!.factures.push(facture);
  });

  return Array.from(groups.values());
}

export function getDossierStatusLabel(status?: number): string | null {
  if (status === 1) return "Facturé";
  if (status === 2) return "Non facturé";
  return null;
}

export type SortDirection = "asc" | "desc";

export type FactureSortKey = "libelle" | "numero" | "patient" | "debut" | "fin" | "rc" | "ro" | "montant";

const factureSortAccessors: Record<FactureSortKey, (f: ReportFacture) => string | number> = {
  libelle: (f) => f.libelle || "",
  numero: (f) => f.numero || "",
  patient: (f) => f.patient || "",
  debut: (f) => f.debut || "",
  fin: (f) => f.fin || "",
  rc: (f) => parseFloat(f.rc || "0"),
  ro: (f) => parseFloat(f.ro || "0"),
  montant: (f) => parseFloat(f.montant || "0"),
};

export function sortFactures(factures: ReportFacture[], sortKey: FactureSortKey | null, direction: SortDirection): ReportFacture[] {
  if (!sortKey) return factures;

  const accessor = factureSortAccessors[sortKey];
  const sorted = [...factures].sort((a, b) => {
    const va = accessor(a);
    const vb = accessor(b);
    if (typeof va === "number" && typeof vb === "number") return va - vb;
    return String(va).localeCompare(String(vb), "fr", { numeric: true });
  });

  return direction === "asc" ? sorted : sorted.reverse();
}
